// Social media & print format presets (width x height in px)
export const FORMATS = [
  { id: "ig-post", label: "Instagram Post", w: 1080, h: 1080 },
  { id: "ig-portrait", label: "Instagram Portrait", w: 1080, h: 1350 },
  { id: "ig-story", label: "Instagram Story / Reel", w: 1080, h: 1920 },
  { id: "fb-post", label: "Facebook Post", w: 1200, h: 630 },
  { id: "fb-story", label: "Facebook Story", w: 1080, h: 1920 },
  { id: "x-post", label: "X / Twitter Post", w: 1600, h: 900 },
  { id: "li-post", label: "LinkedIn Post", w: 1200, h: 627 },
  { id: "pin", label: "Pinterest Pin", w: 1000, h: 1500 },
  { id: "yt-thumb", label: "YouTube Thumbnail", w: 1280, h: 720 },
  { id: "tiktok", label: "TikTok", w: 1080, h: 1920 },
  { id: "a4", label: "A4 Flyer (Print)", w: 1240, h: 1754 },
  { id: "poster", label: "Poster", w: 1080, h: 1350 },
];

export const findFormat = (w, h) => FORMATS.find((f) => f.w === w && f.h === h)?.id || "";
